var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgRedInfo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "red-info",
    transform: "translate(27)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "icon-attention",
    d: "M11.5,4A7.5,7.5,0,1,0,19,11.5,7.509,7.509,0,0,0,11.5,4Zm-.563,3.938a.562.562,0,1,1,1.125,0v4.5a.562.562,0,0,1-1.125,0Zm.563,7.687a.75.75,0,1,1,.75-.75A.75.75,0,0,1,11.5,15.625Z",
    transform: "translate(-31 -4)",
    fill: "#e23a45"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRedInfo);
export default __webpack_public_path__ + "static/media/red-info.b409abb61b3fa318fcc0179546b60407.svg";
export { ForwardRef as ReactComponent };